import { makeStyles, tokens } from "@fluentui/react-components";

export const useActiveStyle = makeStyles({
	item: {
		backgroundColor: tokens.colorNeutralBackground1Hover,
	},
	itemSelected: {
		backgroundColor: tokens.colorBrandBackground2,

		"&:hover": {
			backgroundColor: tokens.colorBrandBackground2,
		},
	},
	itemInPreview: {
		backgroundColor: tokens.colorNeutralBackground1Hover,
		border: `3px solid ${tokens.colorBrandStroke2} !important`,

		"&:hover": {
			backgroundColor: tokens.colorNeutralBackground1Hover,
			border: `1px solid ${tokens.colorBrandStroke2}`,
		},
	},
	mainTextSelected: {
		fontWeight: tokens.fontWeightSemibold,
	},
});
